import type { SVGProps } from 'react';

export const BottomPanelOpen = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.55 14.5v-5c0-.217-.092-.358-.275-.425-.183-.083-.35-.05-.5.1l-2.2 2.2a.904.904 0 0 0 0 1.25l2.2 2.2c.15.15.317.192.5.125.183-.083.275-.233.275-.45Zm8.95 4.2c0 .5-.175.925-.525 1.275-.35.35-.775.525-1.275.525H5.3c-.5 0-.925-.175-1.275-.525A1.736 1.736 0 0 1 3.5 18.7V5.3c0-.5.175-.925.525-1.275.35-.35.775-.525 1.275-.525h13.4c.5 0 .925.175 1.275.525.35.35.525.775.525 1.275v13.4ZM16 19h2.7c.067 0 .133-.033.2-.1s.1-.133.1-.2V5.3c0-.067-.033-.133-.1-.2s-.133-.1-.2-.1H16v14Zm-1.5 0V5H5.3c-.067 0-.133.033-.2.1s-.1.133-.1.2v13.4c0 .067.033.133.1.2s.133.1.2.1h9.2Zm1.5 0h3-3Z" />
    </svg>
  );
};
